export default "__VITE_ASSET__d07896fc__"